var agentModal = {
    isOpened: false,
    init: function() {
        var _this = this;
        if ($(".enquire_project_product_agent").length < 1 ) { return; }

        // === OPEN AGENT MODAL
        $(".enquire_project_product_agent").off('click').on('click', function (e) {
            e.preventDefault();

            var agentModal = $('#agent_modal');
            var btn = $(this);
            var navEmailBtn = $('#navbar').find('.agent-item .enquire_project_product_agent');

            // // Mobile: Close
            // if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
            // }

            // Mobile: fade out modal
            if (_this.isOpened) {
                if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
                    agentModal.find('.modal-close').trigger('click');
                    _this.isOpened = false;

                    navEmailBtn.removeClass('off');
                    // btn.find('.text').html('Email');
                }
            } 
            // Fade in modal
            else {


                // == Replace details in form col
                var agentId = $(this).attr("data-agent-id");
                var agentName = $(this).attr("data-agent-name");
                var listingName = $(this).attr("data-name");
                var listingLocation = $(this).attr("data-location");


                // update hidden field with agent id
                $("#popup_enquire_agent_id").val(agentId);

                // update form heading
                $('#enquire_popup_heading').html(agentName);

                var subheading = '';
                if ( listingName ) {
                    subheading = listingName;
                } 
                if ( listingLocation ) {
                    subheading += ', ' + listingLocation;
                }
                $("#enquire_popup_subheading").html(subheading);

                
                // == Go to slide
                var agentID = $(this).attr('data-agent-id');
                var thisSlide = agentModal.find('.agent-item[data-agent-id="'+agentID+'"]');
                var slideId = thisSlide.attr('data-slick-index');

                var modalSlider = agentModal.find('.agent-slider');
                if ( modalSlider.length > 0 && modalSlider.hasClass('slick-initialized') ) {
                    modalSlider.slick('slickGoTo',slideId);
                }

                // == Fade in Modal
                // if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
                //     var backdrop = true;
                // } else {
                //     var backdrop = false;
                // }
                // agentModal.modal({
                //     backdrop: backdrop
                // });

                agentModal.modal('show');

                _this.isOpened = true;

                if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 

                    // update button to say "close"
                    // btn.find('.text').html('Close');
                    navEmailBtn.addClass('off');
                }


                // == Stop navbar slider autoplay (only if navbar visible)
                if ( $('#navbar.fixed .agent-slider').length > 0 ) {
                    var slider = $('#navbar .agent-slider');
                    if ( slider.hasClass('slick-initialized') ) {
                        slider.slick('pause');
                        slider.slick('setOption', 'autoplay', false); // to set pause on hover option
                    }
                } 
            }


            

        });


        // === CLICK ON IMAGE: OPEN MODAL
        $('.agent_listing_enquire_open_popup').off('click').on('click', function(e){
            e.preventDefault();
            $(this).parent('.agent-info').find('.enquire_project_product_agent').click();
        })



        // === CLOSE AGENT MODAL ON CLICK ON OVERLAY
        $("#agent_modal").on('click', function (e) {
            var modal = $(this);
            if ( $(e.target).hasClass('modal-dialog') || $(e.target).hasClass('modal-overlay') ) {
                // $('#agent_modal').modal('hide');
                modal.find('.modal-close').trigger('click');
            }
        });

        // === CLOSE AGENT MODAL ON CLICK "view bio"
        // $("#agent_modal .agent-details.has-bio .text-link").on('click', function (e) {
        //     var modal = $(this).parents('#agent_modal');
        //     modal.find('.modal-close').trigger('click');
        // });

        // === WHEN CLOSING AGENT MODAL...
        $('#agent_modal').on('hide.bs.modal', function(){
            // play agent slider in navbar (only if navbar visible and desktop)
            if ( $('#navbar.fixed .agent-slider').length > 0 && !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)") ) {
                var slider = $('#navbar .agent-slider');
                if ( slider.hasClass('slick-initialized') ) {
                    slider.slick('play');
                    slider.slick('setOption', 'autoplay', true); // to set pause on hover option

                }
            } 
        })
        $('#agent_modal').on('hidden.bs.modal', function(){
            _this.isOpened = false;        
        })
    },

    destroy: function() {
        var _this = this;

        // if ($(".enquire_project_product_agent").length < 1 ) { return; }

        // hide modal
        if ( $('#agent_modal').length > 0 ) {
            $('#agent_modal').modal('hide');
            $("#agent_modal").off('click');
            $("#agent_modal").off('hide.bs.modal');
        }
        
        // remove events.
        // $(".enquire_project_product_agent").off('click');
        // $("#agent_modal").off('click');
        // $("#agent_modal").off('hide.bs.modal');

        // if ( $(".agent_listing_enquire_open_popup").length > 0 ) {
        //     $(".agent_listing_enquire_open_popup").off('click');
        // }

        _this.isOpened = false;

        $(".enquire_project_product_agent").removeClass('off');
    }
            
    
}